export default "__VITE_ASSET__35ef59fa__"